const PencilEditIcon = ({ color, height, width}) => {
  return (
    <svg
      width={height ? height : "19"}
      height={width ? width : "20"}
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.1414 3.57596C11.7313 2.93679 12.0263 2.61721 12.3397 2.4308C13.096 1.981 14.0273 1.96701 14.7962 2.3939C15.1149 2.57082 15.4189 2.88141 16.027 3.50258C16.6351 4.12376 16.9391 4.43434 17.1123 4.75988C17.5302 5.54537 17.5165 6.49669 17.0762 7.26929C16.8937 7.58948 16.5809 7.8908 15.9552 8.49344L8.51059 15.6638C7.32487 16.8058 6.73201 17.3769 5.99106 17.6663C5.2501 17.9557 4.43554 17.9344 2.80642 17.8918L2.58477 17.886C2.08881 17.873 1.84083 17.8665 1.69668 17.7029C1.55253 17.5393 1.57221 17.2867 1.61157 16.7815L1.63294 16.5072C1.74372 15.0853 1.79911 14.3743 2.07678 13.7352C2.35444 13.0961 2.83339 12.5772 3.7913 11.5394L11.1414 3.57596Z"
        stroke={color ? color : "#828282"}
        stroke-width="1.5"
        stroke-linejoin="round"
      />
      <path
        d="M10.291 3.66663L15.8327 9.20829"
        stroke={color ? color : "#828282"}
        stroke-width="1.5"
        stroke-linejoin="round"
      />
      <path
        d="M11.083 17.9166L17.4163 17.9166"
        stroke={color ? color : "#828282"}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default PencilEditIcon;
